import React from "react";
import '.././PopupCommonStyle.css'
import styles from "./Style.module.css";
import { BtnSecondary } from "../../Buttons/BtnSecondary";
import { BtnPrimary } from "../../Buttons/BtnPrimary";

export const BookingCancelConfirmationPopup = ({
  active,
  handleClick,
  cancelAppointment,
  rescheduleBooking,
  rescheduleDisabled,
  cancelAppointmentDisabled,
  isProcessing,
}) => {
  return (
    <div
      className={`popup ${styles.bookingCancelConfirmationPopup} ${
        active ? "show" : ""
      }`}
    >
      <div className={`${styles.popHeader} popup-header`}>
        <h2 className="title">
        Cancel Booking?
        </h2>
        <p className="titleSub">
        Are you sure you want to cancel this booking? This action cannot be undone.
        </p>
      </div>
      <div className={`${styles.footer} popup-footer`}>
          <BtnSecondary
            label="Close"
            handleClick={handleClick}
            disabled={isProcessing}
            customClass="w-100 no-icon"
          />
          <BtnPrimary
            label={isProcessing ? "Processing" : "Cancel Booking"}
            varient="danger"
            handleClick={cancelAppointment}
            disabled={cancelAppointmentDisabled || isProcessing}
            customClass="no-icon w-100"
          />
      </div>
    </div>
  );
};
